import React from 'react';
import b from 'b_';
import cn from 'classnames';
import './ConsoleFragments.css';

const block = b.lock('ConsoleCardTitle');

// an alternative to ConsoleCardHeader
export default function ConsoleCardTitle({ className, ...props }) {
    return <div
        className={cn(block(), className)}
        {...props}
    />;
}
